import  gql  from 'graphql-tag'

export const analystTypes = gql`query analystTypes($isActive: Boolean){ 
    analystTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
